import { PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import App from '../../App';

const BlankLayout = ({ children }: PropsWithChildren) => {
    return (
        <App>
            <div className="text-black dark:text-white-dark min-h-screen">{children ?? <Outlet />} </div>
        </App>
    );
};

export default BlankLayout;
